import IUpdateDisposalSiteRequestModel from "interfaces/Request/IUpdateDisposalSiteRequestModel";
import { GlobalState } from "little-state-machine";

export const updateEditDisposalSiteRequest = (
  state: GlobalState,
  editdisposalSiteRequest: IUpdateDisposalSiteRequestModel
) => ({
  ...state,
  editdisposalSiteRequest
});
